import React, { useEffect, useState } from "react";
import { Timestamps, colors, imageMap } from "../utils/constants";
// import { parse, isValid, format, isAfter, isBefore } from 'date-fns';
// import { enAU } from 'date-fns/locale';
import { db } from "../firebase-config";
import { addDoc, collection, deleteDoc, doc, getCountFromServer, getDoc, getDocs, query, setDoc, where } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import BackButton from '../assets/Back.png'
import { getUrlParams, getSeconds, getFirebaseDocs, randomString, preserveLatestValuesInBooking, removeRide } from "../utils/common";
import Close from '../assets/Close.png';
import toast from 'react-hot-toast';
import { format, isAfter, isSameDay } from "date-fns";
import ModalComponent from "../components/Modal";
import { useDispatch, useSelector } from "react-redux";
import { clearBookings, setBookings } from "../redux/bookingReducer";

import axios from 'axios'

const Checkout = () => {

    const [mode, setMode] = useState('CartView')  //CartView and CheckoutDone
    const [pendingBookings, setPendingBookings] = useState([])
    const [pastBookings, setPastBookings] = useState([])
    const [loading, setLoading] = useState(false)
    const [cart, setCart] = useState([])
    const [date, setDate] = useState()
    const [userData, setUserData] = useState()

    const [declarationChecked, setDeclarationChecked] = useState(false)
    const [parentName, setParentName] = useState('')
    const [showDeclarationPopup, setShowDeclarationPopup] = useState(false)
    const [declarationError, setDeclarationError] = useState('')

    const [showConfimationPopup, setShowConfirmationPopup] = useState(false)
    const [showErrorTimeslotSpacingPopup, setShowErrorTimeslotSpacingPopup] = useState()

    const [existingBookingId, setExistingBookingId] = useState('')

    const navigate = useNavigate()
    const dispatch = useDispatch()

    // console.log('cart', cart)
    const bookings = useSelector((state) => state.bookings.value)
    const staff = useSelector((state) => state.staff.value)

    const userId = window.localStorage.getItem('config:userId')
    // console.log('userId', userId)

    useEffect(() => {
        if (!userId && window.location.pathname !== '/') {
            navigate('/')
        } else {

            const params = getUrlParams()
            if (!params.dt) {
                navigate('/')
                return
            }
            setDate(params.dt)
            getPastBookingId()

            if (!bookings) {
                getPendingBookings()
            } else {
                setPendingBookings(bookings)
            }
            getUserData()
        }
    }, [])


    useEffect(() => {
        if (bookings) {
            setPendingBookings(bookings)
        }
    }, [bookings])


    const getPastBookingId = async () => {
        const existingBookings = await getFirebaseDocs(await getDocs(await query(collection(db, 'bookings'), where('userId', '==', userId))))
        if (existingBookings.length > 0) {
            setExistingBookingId(existingBookings[0].id)
            // setPastBookings(localPastbookings)
        } else {
            setExistingBookingId(randomString())
        }
    }

    useEffect(() => {
        if (pendingBookings.length > 0) {
            fetchCartItems()
        }
    }, [pendingBookings])


    useEffect(() => {
        if (cart.length > 0) {
            checkIfTimeslotsSpaced30MinsApart(cart.filter(row => row.id.split('-')[1] === '29'))
            checkIfTimeslotsSpaced30MinsApart(cart.filter(row => row.id.split('-')[1] === '30'))
        }
    }, [cart])


    const checkIfTimeslotsSpaced30MinsApart = (cartForDay) => {
        let timeslotsHave30MinsGap = true
        // Check if timeslots have 30 min gap  (1800 seconds subtracting 1 second from 30 mins)
        let previousTime = 0
        // Group times by day and then apply filter?

        cartForDay.forEach(row => {
            if (previousTime === 0) {
                previousTime = row.start
            } else if (row.start === previousTime || ((previousTime + 1800) > row.start)) {
                timeslotsHave30MinsGap = false
            }
            previousTime = row.start
        })

        if (!timeslotsHave30MinsGap) {
            toast.error(`Please make sure that your rides start at 30 mins from each other.`)
        }
        return timeslotsHave30MinsGap
    }

    const getUserData = async () => {
        const existingDoc = await (await getDoc(doc(db, 'users', userId))).data()
        setUserData(existingDoc)
    }


    const getPendingBookings = async () => {

        let pending_and_past_bookings = []

        const existingBookings = await getFirebaseDocs(await getDocs(await query(collection(db, 'bookings'), where('userId', '==', userId))))
        if (existingBookings.length > 0) {

            const localPastbookings = existingBookings.map(row => row.rides).flat()
            setExistingBookingId(existingBookings[0].id)
            // setPastBookings(localPastbookings)
            pending_and_past_bookings = localPastbookings
        } else {
            setExistingBookingId(randomString())
        }

        const pending_booking_id = window.localStorage.getItem(`config:pending_booking_id-${userId}`)

        if (pending_booking_id) {
            const existingBooking = await (await getDoc(doc(db, 'pending_bookings', pending_booking_id))).data()
            if (existingBooking) {
                pending_and_past_bookings = [...pending_and_past_bookings, ...existingBooking.rides]
                // setPendingBookings(existingBooking.rides)
            }
        } else {
            // navigate('/pickDate')
            // Create new pending booking id to be able to edit past bookings in current session.
            const pendingId = randomString()
            await setDoc(doc(db, 'pending_bookings', pendingId), { rides: [], userId })
            window.localStorage.setItem(`config:pending_booking_id-${userId}`, pendingId)
        }

        dispatch(setBookings(preserveLatestValuesInBooking(pending_and_past_bookings)))
        // setPendingBookings(preserveLatestValuesInBooking(pending_and_past_bookings))

    }

    const fetchCartItems = async () => {
        const rideInformation = await (await getDoc(doc(db, 'rides', date))).data()
        const cartItems = await Promise.all(pendingBookings.map(async event => {
            const timeName = event.split('-')[2]
            const rideId = event.split('-')[0]
            const matchingRide = rideInformation.data.filter(r => !r.disabled).find(row => row.id == rideId)
            const rideTimeSlot = await (await getDoc(doc(db, 'timeslots', `${rideId}-${date}`))).data()
            const matchingTimeSlot = rideTimeSlot.times.find(row => row.name === timeName)
            return ({ id: event, rideId, start: matchingTimeSlot ? matchingTimeSlot.start : 0, name: matchingRide.name, icon: imageMap[rideId], time: timeName })
        }))

        setCart(cartItems.sort((a, b) => a.start - b.start))
    }

    const removeCartItem = async (e, id) => {
        e.stopPropagation()
        const pending_booking_id = window.localStorage.getItem(`config:pending_booking_id-${userId}`)
        // const pendingBookingsDontIncludingPast = pendingBookings.filter(row => !pastBookings.includes(row))

        let newPendingBookings = removeRide(pendingBookings, id)

        await (await setDoc(doc(db, 'pending_bookings', pending_booking_id), { rides: newPendingBookings }, { merge: true }))

        dispatch(setBookings(preserveLatestValuesInBooking(newPendingBookings)))
        // setPendingBookings(newPendingBookings)

        if (newPendingBookings.length === 0) {
            navigate(-1)
        } else {
            // await getPendingBookings()
        }
    }

    const createBooking = async () => {
        // check quantity and update.

        let errorRides = []

        for (let cartItem of cart) {
            const resp = await getCountFromServer(await query(collection(db, 'bookings'), where('rides', 'array-contains', `${cartItem.rideId}-${date}-${cartItem.time}`)))
            const count = await resp.data().count
            const rideTimeslots = await (await getDoc(doc(db, 'timeslots', `${cartItem.rideId}-${date}`))).data()
            const matchingTime = rideTimeslots.times.find(row => row.name === cartItem.time)

            // const quantityToCheckWith = isSameDay(new Date(), new Date(2023, 6, parseInt(date))) ? matchingTime.capacity : matchingTime.quantity
            const quantityToCheckWith = matchingTime.quantity
            if (count >= quantityToCheckWith) {
                errorRides.push(cartItem.name)
            }
        }

        if (errorRides.length > 0) {
            setShowConfirmationPopup(false)
            toast.error(`${errorRides.join(', ')} are not available anymore! Please update your cart.`)
        } else {
            const pending_booking_id = window.localStorage.getItem(`config:pending_booking_id-${userId}`)
            // Trigger email send here.

            try {

                await setDoc(doc(db, 'bookings', existingBookingId), { rides: pendingBookings, userId, Created: getSeconds(), date: format(new Date(), 'dd/MMM/yyyy') })
                await deleteDoc(doc(db, 'pending_bookings', pending_booking_id))
                setPendingBookings([])
                window.localStorage.removeItem(`config:pending_booking_id-${userId}`)
                setLoading(true)
                await axios.post(`https://sendbookingemail-7cwqgfqj4a-ts.a.run.app`, { id: userId })
                setLoading(false)
                setShowConfirmationPopup(false)
                setMode('CheckoutDone')
            } catch (e) {
                // console.error('e', e)                
                // setShowConfirmationPopup(false)
                // window.alert('Error occurred sending email!')

                //  hiding error message.
                setLoading(false)
                setShowConfirmationPopup(false)
                setMode('CheckoutDone')
            }
        }
    }

    const clearExistingSession = async () => {
        window.localStorage.removeItem('config:userId')
        dispatch(clearBookings());
        setTimeout(() => navigate(`/`), 100)
    }


    const handleShowConfirmationPopup = () => {
        const Day29Rides = cart.filter(row => row.id.split('-')[1] === '29')
        const Day30Rides = cart.filter(row => row.id.split('-')[1] === '30')

        const hasEvenlySpacedSlots29 = checkIfTimeslotsSpaced30MinsApart(Day29Rides)
        const hasEvenlySpacedSlots30 = checkIfTimeslotsSpaced30MinsApart(Day30Rides)

        // Hide rides.
        if (Day29Rides.length > 0 && isAfter(new Date(), new Date(Timestamps.Saturday))) {
            toast.error('Your cart has rides on 29 July, the time for booking them has expired. Please remove those rides and proceed.', { position: 'top-center' })
            return
        }
        if (Day30Rides.length > 0 && isAfter(new Date(), new Date(Timestamps.Sunday))) {
            toast.error('Your cart has rides on 30 July, the time for booking them has expired. Please remove those rides and proceed.', { position: 'top-center' })
            return
        }

        if (!hasEvenlySpacedSlots29 || !hasEvenlySpacedSlots30) {
            setShowErrorTimeslotSpacingPopup(true)
        } else {
            // Show declaration here if not admin?
            if (staff) {
                setShowConfirmationPopup(true)
            } else {
                setShowDeclarationPopup(true)
            }
        }
    }


    const submitDeclaration = async () => {
        if (!declarationChecked) {
            setDeclarationError('Please accept the terms.')
            return
        }
        if (!parentName) {
            setDeclarationError('Please enter your name.')
            return
        }
        setDeclarationError('')
        setLoading(true)
        await setDoc(doc(db, 'users', userId), { declarationDate: new Date().toISOString(), declarationParentName: parentName, declarationSeconds: getSeconds() }, { merge: true })
        setLoading(false)
        setShowDeclarationPopup(false)
        setShowConfirmationPopup(true)
    }

    return (<div className="container">

        {mode === 'CartView' && <div tabIndex={0}>
            <img src={BackButton} className="back-button" onClick={() => navigate(-1)} />
        </div>}

        {mode === 'CartView' && <h2 style={{ margin: '-40px auto 20px', color: colors.red }}>Your Day</h2>}
        {/* {
            mode === 'CheckoutDone' &&
            <h2 style={{ margin: '20px auto', color: colors.red }}>Booking Confirmed</h2>
        } */}


        <ModalComponent showModal={!!showErrorTimeslotSpacingPopup} setShowModal={setShowErrorTimeslotSpacingPopup}>
            <> <h2 style={{ textAlign: 'center' }}>Your rides are not 30 mins apart from each other!</h2>
                <p style={{ textAlign: 'center' }}> Please change your timings before proceeding.</p>
                <div style={{ display: 'flex' }}>
                    <button onClick={() => setShowErrorTimeslotSpacingPopup(false)}>Close</button>
                </div>
            </>
        </ModalComponent>

        <ModalComponent showModal={!!showDeclarationPopup} setShowModal={setShowDeclarationPopup}>
            <> <h2 style={{ textAlign: 'center' }}>IMPORTANT CONTRACT AGREEMENT AND RISK WARNING</h2>
                <div style={{ display: 'flex', flexDirection: 'column', height: '60vh', overflow: 'scroll' }}>
                    <p style={{ textAlign: 'center' }}>Glenworth Valley Adventures P/L A.C.N. 654 339 698 (the Provider) &ndash; Trading as<br /><strong>GLENWORTH VALLEY WILDERNESS ADVENTURES</strong><br />69 Cooks Road, Glenworth Valley NSW 2250<br />
                        <br /><br /><strong>HORSES BIRTHDAY 2023</strong>

                    </p>
                    <p>
                        <br />
                        <strong><u>CONDITIONS</u></strong>
                        <br /><br />1.The Provider (defined below) agrees to organise and allow the Participant (defined above) to participate in the Recreational Activity (defined below) and Amusement rides (defined below).
                        <br /><br />2.The Ticket and Participation Fee (defined below) has been paid by the Participant or on behalf of the Participant in consideration for the Provider allowing the Participant to participate in the Amusement ride or Recreational Activity.
                        <br /><br />3.The Participant / Guardian and the Provider agree that this document contains the terms and conditions of the contract between them in relation to the services provided by the Provider to the Participant.
                        <br /><br />4.The Participant / Guardian warrants that the Participant / Guardian has read and carefully considered this contract including the General Description of Risks before participating in the Recreational Activity and amusement rides and that the Participant / Guardian does not suffer from any disability, illness, health issue or impairment which may affect participation in the Recreational Activity.
                        <br /><br />5.The Participant / Guardian warrants that in signing this contract the Participant / Guardian has done so voluntarily and that no pressure or unfair tactics have been used to persuade the Participant / Guardian to sign this contract and that the Participant / Guardian has done so voluntarily in the knowledge that it is open to the Participant / Guardian to refuse to sign the contract.
                        <br /><br />6.The Participant / Guardian warrants that the Participant will comply with all rules, safety instructions and reasonable directions given to the Participant relating to participation in the Recreational Activity and amusement ride.
                        <br /><br />7.Where the Participant is a minor, the Guardian of the Participant enters into this contract on behalf of the Participant, and the Guardian warrants that they have read the section of this contract headed &ldquo;General Description of Risks of recreational activities and amusement rides offered by the Provider&rdquo; to the Participant.
                        <br /><br />8.The Participant / Guardian agrees to be jointly and severally liable for paying the costs of any damage or loss done by the Participant or any other member of the Participants group booking that occurs to the Providers equipment or property whilst it is under their control, including the cost of any debt recovery action that may be necessary and hereby authorise the Provider to debit the credit card used to book the Recreation Activity for any outstanding debt owed by the Participant or any member of your group booking.
                        <br /><br />
                        <strong><u>GENERAL DESCRIPTION OF RISKS OF RECREATIONAL ACTIVITIES AND AMUSMENT RIDES OFFERED BY THE PROVIDER</u></strong></p>
                    <p>Participating in recreational activities and amusement rides is dangerous. &nbsp;The risks include but are not limited to death, serious injury or illness due to:</p>
                    <ul>

                        <li>
                            Inability of the Provider to prevent all accidents from occurring due to the actions of other participants and horses including collisions with other participants, vehicles, horses, pedestrians, objects, structures or colliding with things found in the natural environment such as rocks, trees; difficult terrain and obstacles;</li>
                        <li>
                            Hazardous and changeable conditions in a natural environment, including lightning, strong winds, storms, bushfires, flooding, slippery or muddy conditions;</li>
                        <li>
                            Not adhering to all notices, signs, instructions and directions
                        </li>
                        <li>
                            Not concentrating fully at all times, participant error and/or lack of skill or care and/or dangerous behaviour on your part, the part of other participants or staff
                        </li>
                        <li>
                            Negligence by those involved in organising or providing the activity including staff
                        </li>
                        <li>
                            Falling from your horse or horse stumbling or falling over<br />horses are living animals whose behaviour and responses are impossible to control or predict in every situation
                        </li>
                        <li>
                            Injury as a result of equipment failure or equipment not fitting or being properly fitted;
                        </li>
                        <li>
                            Tripping, falling over or landing heavily;<br />being struck by a falling tree or tree branch;
                        </li>
                        <li>
                            Drowning, falling, being burnt by fire or being struck by a vehicle or animals;
                        </li>
                    </ul>
                    <p>
                        <strong><u>DEFINITIONS</u></strong>

                        <br />&ldquo;Guardian&rdquo; is the Participant&rsquo;s guardian<br />
                        &ldquo;Participation Fee&rdquo; means the fee which has been paid by the Participant or on the Participant&rsquo;s behalf to participate in the Recreational Activity.
                        &nbsp;<br />&ldquo;Provider&rdquo; means Glenworth Valley Adventures P/L A.C.N. 654 339 698 and includes any directors or officers of the Provider, any employees of the Provider, and any person associated with organising the Recreational Activity.<br />
                        &ldquo;Provider&rsquo;s Related Companies&rdquo; means Glenworth Valley Leisure P/L A.C.N. 654 341 750, The Glenworth Valley Group P/L A.C.N. 656 098 761, The Glenworth Valley Pastoral Company P/L A.C.N. 119 657 724 and includes any directors or officers of the Provider&rsquo;s related companies, and any employees of the Provider&rsquo;s related companies.<br />
                        &ldquo;Recreational Activity&rdquo; means any activity organised by the Provider that the Participant intends to participate in, including but not limited to: Horse riding, laser skirmish, inflatable obstacle courses, Rock Climbing, petting farm, giant slides, inflatables, stunt jump, circus activities.<br />
                        &ldquo;Amusement Ride&rdquo; means any mechanical ride organised by the Provider that the Participant intends to participate in, including but not limited to: Chair-o-plane, Bucking Bull.<br /><br />

                    </p>


                    <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
                        <input type="checkbox" id={'declaration'} name={'declaration'} value={declarationChecked} style={{ width: '30px', margin: '6px 0' }} onChange={() => setDeclarationChecked(!declarationChecked)} />
                        <label for={'declaration'} style={{ marginTop: '3px', marginLeft: '4px' }}> I have read and understood the above waiver and give permission for <i>{userData && userData.name} </i> to participate in these activities.  We understand that Glenworth Valley will not be held liable for any injuries as mentioned in the above waiver.</label><br />
                    </div>
                    <label>Name of Parent/Guardian:</label>
                    <input value={parentName} onChange={(e) => setParentName(e.target.value)} />
                    <label>Date: {format(new Date(), 'dd/MM/yyy hh:mm a')}</label>

                    {declarationError && <p style={{ textAlign: 'center', color: 'red' }}> {declarationError}</p>}

                    <div style={{ display: 'flex' }}>
                        <button disabled={loading} onClick={submitDeclaration}>{loading ? 'Loading...' : 'Submit'}</button>
                        <button className="secondary-button" onClick={() => setShowDeclarationPopup(false)}>Cancel</button>
                    </div>
                </div>
            </>
        </ModalComponent>

        <ModalComponent showModal={!!showConfimationPopup} setShowModal={setShowConfirmationPopup}>
            <> <h2 style={{ textAlign: 'center' }}>Are you sure you want to book these rides for the day?</h2>
                <p style={{ textAlign: 'center' }}> This will create a booking and send a confirmation to your email.</p>
                <div style={{ display: 'flex' }}>
                    <button onClick={createBooking} disabled={loading}>{loading ? 'Loading...' : 'Continue'}</button>
                    <button className="secondary-button" onClick={() => setShowConfirmationPopup(false)}>Cancel</button>
                </div>
            </>
        </ModalComponent>

        {mode === 'CheckoutDone' && <>

            <h4 style={{ color: colors.teal, fontSize: '21px', marginBottom: 0, textAlign: 'center' }}> How Exciting... your rides are booked !</h4>
            <p style={{ textAlign: 'center' }}> A confirmation of your selected rides will be emailed to you prior to the event. There is limited mobile phone reception at Glenworth Valley so please screenshot or print out your confirmation prior to the weekend. </p>
            <p style={{ textAlign: 'center', marginTop: 0 }}>We look forward to seeing you at the Horses Birthday Festival! </p>

            {/* <h4 style={{ color: colors.red, marginTop: '15px', fontSize: '21px', marginBottom: '10px', textAlign: 'center' }}>Your booking for {date} July 2023.</h4> */}

            <div className="noScreen">
                <h4 style={{ marginTop: '15px', fontSize: '21px', marginBottom: '10px', textAlign: 'center' }}>Child's Name: {userData.name}</h4>
            </div>

            {cart.filter(row => row.id.split('-')[1] === '29').length > 0 && <h4>29th July 2023</h4>}
            {cart.filter(row => row.id.split('-')[1] === '29').map(row => <div key={row.id} className="ride-row">
                <img src={row.icon} />
                <h2>{row.name}</h2>
                <p>{row.time}</p>
            </div>)}

            {cart.filter(row => row.id.split('-')[1] === '30').length > 0 && <h4>30th July 2023</h4>}
            {cart.filter(row => row.id.split('-')[1] === '30').map(row => <div key={row.id} className="ride-row">
                <img src={row.icon} />
                <h2>{row.name}</h2>
                <p>{row.time}</p>
            </div>)}

            <button className="hide-print" style={{ backgroundColor: colors.mustard }} onClick={() => window.print()}>Print Page</button>

            <button className="hide-print" onClick={clearExistingSession}>Book for another child</button>
        </>}

        {mode === 'CartView' &&
            <>
                {cart.filter(row => row.id.split('-')[1] === '29').length > 0 && <h4>29th July 2023</h4>}

                {cart.filter(row => row.id.split('-')[1] === '29').map(row => <div key={row.id} className="ride-row">
                    <img src={row.icon} className="hover" onClick={() => navigate(`/selectRide?dt=${date}`, { state: { id: row.id } })} />
                    <h2 className="hover" onClick={() => navigate(`/selectRide?dt=${date}`, { state: { id: row.id } })} >{row.name}</h2>
                    <p className="hover" onClick={() => navigate(`/selectRide?dt=${date}`, { state: { id: row.id } })} >{row.time}</p>
                    <img src={Close} className="remove-cart-item hover" onClick={(e) => removeCartItem(e, row.id)} />
                </div>)}

                {cart.filter(row => row.id.split('-')[1] === '30').length > 0 && <h4> 30th July 2023</h4>}

                {cart.filter(row => row.id.split('-')[1] === '30').map(row => <div key={row.id} className="ride-row">
                    <img src={row.icon} className="hover" onClick={() => navigate(`/selectRide?dt=${date}`, { state: { id: row.id } })} />
                    <h2 className="hover" onClick={() => navigate(`/selectRide?dt=${date}`, { state: { id: row.id } })} >{row.name}</h2>
                    <p className="hover" onClick={() => navigate(`/selectRide?dt=${date}`, { state: { id: row.id } })} >{row.time}</p>
                    <img src={Close} className="remove-cart-item hover" onClick={(e) => removeCartItem(e, row.id)} />
                </div>)}

                {cart.length > 0 && <button onClick={handleShowConfirmationPopup}>Continue</button>}
            </>
        }

    </div >)
}

export default Checkout